
'use client'
import { Utils } from "@/lib/utils";
import { useTheme } from "next-themes";
import Image from "next/image";

interface LogoProps {
      width?: number;
      height?: number;
      className?: string;
}

const Logo = ({ width = 100, height = 50, className }: LogoProps) => {
      const { theme } = useTheme();
      return (
            <Image src={theme !== 'dark' ? Utils.image.getImageUrl('/logo/logo_light.png') : Utils.image.getImageUrl('/logo/logo_dark.png')} alt="Kiwilog" width={width} height={height} className={className} />
      )
}

export default Logo;
